export default __webpack_public_path__ + "static/media/image_9.b3d4f59e.jpg";